import styled from 'styled-components';

import { maxDeviceWidth, minDeviceWidth } from '@nw/shared/utils';

export const ApplicationSectionsPageContainer = styled.div`
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: #f1f5f9;
  align-items: center;
`;

export const ApplicationSectionsContainer = styled.div`
  background-color: #f1f5f9;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 162px 44px 44px;
  max-width: 1500px;

  ${maxDeviceWidth(1399)} {
    max-width: 100%;
    padding: 162px 44px 44px;
  }
  ${maxDeviceWidth(1199)} {
    flex-direction: column;
    overflow: auto;
    padding: 44px 55px;
  }
  ${maxDeviceWidth(768)} {
    padding: 16px 24px;
  }
`;

export const MobileSectionTabWrapper = styled.div`
  display: flex;
  width: 100%;
  ${minDeviceWidth(1200)} {
    display: none;
  }
`;

export const FieldContainer = styled.div<{ css?: string }>`
  position: relative;
  width: 100%;

  .informedInputLabelCheckboxText {
    align-items: flex-start;
    cursor: pointer;

    @media (max-width: 768px) {
      font-size: 12px !important;
      line-height: 20px !important;
    }
  }

  .informedInputLabelCheckboxText > div:nth-child(2) {
    margin-top: 2px !important;
    @media (max-width: 768px) {
      margin-top: 4px !important;
    }
  }

  .informedInputLabelCheckboxText svg > rect[width='16'] {
    fill: #16a34a !important;
  }
  .informedInputLabelCheckboxText svg > rect[width='15'] {
    stroke: #cbd5e1 !important;
  }

  .getOTPFieldButtonClassName {
    height: 36px;
    width: 108px;
    margin-top: 24px;
    margin-left: 8px;
    background-color: #991b1b !important;
    * {
      pointer-events: none;
    }
    @media screen and (max-width: 580px) {
      margin: 12px 0px 6px;
      width: 100%;
    }
  }
  .informed-select-label-text {
    margin-bottom: 4px;
  }

  .hideEditButtonClassName {
    display: none !important;
  }

  ${(props) => props.css};
`;
